import React from 'react'

function CociDetails() {
  return (
    <div>CociDetails</div>
  )
}

export default CociDetails